import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/layout.css';

export default function Layout() {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <Link to="/" className="logo" aria-label="Go to home page">
            <h1>DS Web Emulator</h1>
          </Link>

          <nav className="nav">
            {isAuthenticated ? (
              <>
                <Link to="/dashboard" className="nav-link">
                  Dashboard
                </Link>
                <Link to="/emulator" className="nav-link">
                  Emulator
                </Link>
                <div className="user-menu">
                  <span className="user-email">{user?.email}</span>
                  <button
                    onClick={handleLogout}
                    className="btn btn-secondary"
                    aria-label="Log out of your account"
                  >
                    Logout
                  </button>
                </div>
              </>
            ) : (
              <>
                <Link to="/login" className="nav-link">
                  Login
                </Link>
                <Link to="/register" className="btn btn-primary">
                  Sign up
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>

      <main className="main-content">
        <Outlet />
      </main>

      <footer className="footer">
        <p>
          Nintendo DS Web Emulator - Bring your own ROMs | Built with melonDS
        </p>
        <p className="footer-disclaimer">
          This emulator does not include any copyrighted content. Users must provide legally obtained ROM files.
        </p>
      </footer>
    </div>
  );
}
